var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default_drag_comp"},on:{"click":_vm.goNextNav,"touchstart":_vm.down,"touchmove":_vm.move,"touchend":_vm.end}})}
var staticRenderFns = []

export { render, staticRenderFns }